<script setup>
import { useRouter } from "vue-router";
import AppDataTable from "@/components/AppDataTable.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { useResourceList } from "@/composables/useResourceList";
import { fetchMainServices, fetchMoreServices, deleteService } from "./api";
import { ref } from "vue";

const router = useRouter();
const tab = ref("main");
const columns = [
  { key: "title",   label: "Title",   sortable: true },
  { key: "actions", label: "Actions", align: "end", width: "150px" },
];

const mainList = useResourceList({ fetch: fetchMainServices, remove: deleteService, mapRow: (s) => ({ id: s._id, title: s.title, type: "Main" }) });
const moreList = useResourceList({ fetch: fetchMoreServices, remove: deleteService, mapRow: (s) => ({ id: s._id, title: s.title, type: "More" }) });
</script>

<template>
  <section>
    <div class="d-flex align-center justify-space-between mb-4 gap-3 flex-wrap">
      <h1 class="text-h5">Services</h1>
      <div class="d-flex gap-2">
        <VBtn variant="tonal" @click="mainList.load(); moreList.load()">Refresh</VBtn>
        <VBtn @click="router.push({ name: 'services-new' })">Add Service</VBtn>
      </div>
    </div>
    <VTabs v-model="tab" class="mb-4">
      <VTab value="main">Main Services</VTab>
      <VTab value="more">More Services</VTab>
    </VTabs>
    <VAlert v-if="mainList.error.value || moreList.error.value" type="error" class="mb-4">{{ mainList.error.value || moreList.error.value }}</VAlert>
    <AppDataTable v-if="tab === 'main'" :columns="columns" :rows="mainList.rows.value" :loading="mainList.loading.value" row-key="id" searchable search-placeholder="Search services…" empty-text="No main services.">
      <template #cell-actions="{ row }">
        <VBtn size="small" variant="text" @click.stop="router.push({ name: 'services-edit', params: { id: row.id } })">Edit</VBtn>
        <VBtn size="small" color="error" variant="text" @click.stop="mainList.askDelete(row)">Delete</VBtn>
      </template>
    </AppDataTable>
    <AppDataTable v-else :columns="columns" :rows="moreList.rows.value" :loading="moreList.loading.value" row-key="id" searchable search-placeholder="Search services…" empty-text="No more services.">
      <template #cell-actions="{ row }">
        <VBtn size="small" variant="text" @click.stop="router.push({ name: 'services-edit', params: { id: row.id } })">Edit</VBtn>
        <VBtn size="small" color="error" variant="text" @click.stop="moreList.askDelete(row)">Delete</VBtn>
      </template>
    </AppDataTable>
    <ConfirmDialog :model-value="mainList.pendingDelete.value !== null || moreList.pendingDelete.value !== null" title="Delete service?" message="Permanently delete this service?" :loading="mainList.deleting.value || moreList.deleting.value"
      @update:model-value="mainList.pendingDelete.value = null; moreList.pendingDelete.value = null"
      @confirm="mainList.pendingDelete.value ? mainList.confirmDelete() : moreList.confirmDelete()" />
  </section>
</template>
